import { OptimizedImage } from '@/components/shared/OptimizedImage';

interface PlatformLogoProps {
  src?: string | null;
  alt?: string;
  className?: string;
}

export default function PlatformLogo({
  src,
  alt = 'Rork Store',
  className = 'h-12 w-auto object-contain',
}: PlatformLogoProps) {
  return (
    <OptimizedImage
      src={src || '/branding/rork-store-logo.png'}
      alt={alt}
      eager
      sizes="160px"
      className={className}
      draggable={false}
    />
  );
}
